
import { showAlert } from '@root/store/slices/features'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

export function useNotification() {
    const dispatch = useDispatch()
    const { t } = useTranslation('common')

    const showNotification = ({ type, message, ...props }: Data) => {
        dispatch(showAlert({
            type: type === 'something_went_wrong' ? 'error' : type,
            message: message || t('feedback.somethingWrong'),
            ...props
        }))
    }

    return {
        showNotification
    }
}
